import { jsx as _jsx } from "react/jsx-runtime";
import { SignIn } from '@web/components/SignIn';
export var SignInView = function () {
    return _jsx(SignIn, {});
};
